import { render, staticRenderFns } from "./ErrorsDiv.vue?vue&type=template&id=2fd96f8c&scoped=true"
import script from "./ErrorsDiv.vue?vue&type=script&lang=js"
export * from "./ErrorsDiv.vue?vue&type=script&lang=js"
import style0 from "./ErrorsDiv.vue?vue&type=style&index=0&id=2fd96f8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd96f8c",
  null
  
)

export default component.exports